const sharedInit = {
  fallbackLng: 'nl',
  supportedLngs: ['en', 'nl'],
  ns: [
    'about',
    'aboutUs',
    'contact',
    'footer',
    'home',
    'homeContact',
    'license',
    'menu',
    'myWork',
    'notFound',
    'partners',
    'photo',
    'services',
  ],
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
};

export default sharedInit;
